function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 6)",
  stroke: "#2B9D8B",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 6s3.273-6 9-6 9 6 9 6-3.273 6-9 6-9-6-9-6z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 6,
  rx: 2.455,
  ry: 2.25
}));

function SvgPasswordVisibility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisibility);
export default __webpack_public_path__ + "static/media/password_visibility.5d4c35e4.svg";
export { ForwardRef as ReactComponent };